import allGalleryService from '../services/allGalleryService';

const handleResponse = (result, fallbackMessage) => {
  if (!result?.success) {
    const error = new Error(result?.message || fallbackMessage);
    error.details = result;
    throw error;
  }
  return result;
};

export const fetchAllGalleries = async (params = {}) => {
  const result = await allGalleryService.getAll(params);
  const handled = handleResponse(result, 'Galeriler alınamadı');
  return { data: handled.data || [], meta: handled.metaData };
};

export const createGallery = async (payload) => {
  const result = await allGalleryService.create(payload);
  return handleResponse(result, 'Galeri oluşturulamadı').data;
};

export const updateGallery = async (payload) => {
  const result = await allGalleryService.update(payload);
  return handleResponse(result, 'Galeri güncellenemedi').data;
};

export const deleteGallery = async (id) => {
  const result = await allGalleryService.remove(id);
  return handleResponse(result, 'Galeri silinemedi').data;
};

export const fetchGalleryById = async (id) => {
  const result = await allGalleryService.getById(id);
  return handleResponse(result, 'Galeri alınamadı').data;
};

export const fetchGalleriesByType = async (relatedEntityType) => {
  const result = await allGalleryService.getByType(relatedEntityType);
  return handleResponse(result, 'Galeriler alınamadı').data || [];
};

export const fetchGalleriesByRelatedEntity = async (relatedEntityType, relatedEntityId) => {
  const result = await allGalleryService.getByRelatedEntity(relatedEntityType, relatedEntityId);
  return handleResponse(result, 'Galeriler alınamadı').data || [];
};

export const fetchGalleryByRelatedEntityNews = async (newsMongoId) => {
  const result = await allGalleryService.getByRelatedEntityNews(newsMongoId);
  return handleResponse(result, 'Galeri alınamadı').data;
};

export const createEntityGallery = async (payload) => createGallery(payload);

export const addImagesToGallery = async (galleryId, files, altText = null) => {
  const result = await allGalleryService.addImages(galleryId, files, altText);
  return handleResponse(result, 'Görseller eklenemedi').data || [];
};

export const removeImageFromGallery = async (galleryId, imageId) => {
  const result = await allGalleryService.removeImage(galleryId, imageId);
  return handleResponse(result, 'Görsel kaldırılamadı').data;
};

export const reorderGalleryImages = async (galleryId, imageIdsInOrder) => {
  const result = await allGalleryService.reorderImages(galleryId, imageIdsInOrder);
  return handleResponse(result, 'Görseller sıralanamadı').data;
};

export const reorderGalleries = async ({ galleryIdsInOrder }) => {
  const result = await allGalleryService.reorderGalleries({ galleryIdsInOrder });
  return handleResponse(result, 'Galeriler sıralanamadı').data;
};

export default {
  fetchAllGalleries,
  createGallery,
  updateGallery,
  deleteGallery,
  fetchGalleryById,
  fetchGalleriesByType,
  fetchGalleriesByRelatedEntity,
  addImagesToGallery,
  removeImageFromGallery,
  reorderGalleryImages,
  reorderGalleries,
};

